<template>
  <el-dialog :visible.sync="visible" title="查看联系人" :close-on-click-modal="false"
             :close-on-press-escape="false" :append-to-body="true" width="70%">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.searchKey" size="mini" placeholder="联系人/联系电话/地址" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" @click="reload()">{{ $t('query') }}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" v-if="$hasPermission('trade:companycontact:save')" type="primary" @click="addOrUpdateHandle()">
          {{ $t('add') }}
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" v-if="$hasPermission('trade:companycontact:delete')" type="danger" @click="deleteHandle()">
          {{ $t('deleteBatch') }}
        </el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
              style="width: 100%;">
      <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
      <el-table-column prop="contactMan" label="联系人" header-align="center" align="center"></el-table-column>
      <el-table-column prop="contactPhone" label="联系电话" header-align="center" align="center"></el-table-column>
      <el-table-column prop="contactAddress" label="地址" header-align="center" align="center"></el-table-column>
      <el-table-column prop="isDefault" label="是否默认" header-align="center" align="center">
        <template v-slot="{row}">
          <i class="el-icon-success" v-if="row.isDefault===1" style="color:#67C23A;"></i>
          <i class="el-icon-error" v-else style="color:#F56C6C;"></i>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true" header-align="center"></el-table-column>
      <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
        <template slot-scope="scope">
          <el-button v-if="$hasPermission('trade:companycontact:update')" type="text" size="mini"
                     @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" :companyId="dataForm.companyId" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './save'

export default {
  mixins: [mixinViewModule],
  components: {
    AddOrUpdate
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/company/contact/page',
        getDataListIsPage: true,
        exportURL: '/trade/companycontact/export',
        deleteURL: '/trade/company/contact',
        deleteIsBatch: true
      },
      visible: false,
      dataForm: {
        companyId: ''
      }
    }
  },
  methods: {
    init (companyId) {
      this.dataForm.companyId = companyId

      this.reload()
      this.visible = true
    }
  }
}
</script>
